const RAZORPAY_SCRIPT_ID = "razorpay-checkout-sdk";
const RAZORPAY_SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let razorpayLoadPromise: Promise<void> | null = null;

export function ensureRazorpayLoaded(): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.reject(
      new Error("Razorpay can only be loaded in the browser."),
    );
  }

  if (typeof window.Razorpay !== "undefined") {
    return Promise.resolve();
  }

  if (razorpayLoadPromise) {
    return razorpayLoadPromise;
  }

  razorpayLoadPromise = new Promise<void>((resolve, reject) => {
    const existingScript = document.getElementById(
      RAZORPAY_SCRIPT_ID,
    ) as HTMLScriptElement | null;

    const cleanup = () => {
      existingScript?.removeEventListener("load", onLoad);
      existingScript?.removeEventListener("error", onError);
    };

    function onLoad() {
      cleanup();

      if (typeof window.Razorpay !== "undefined") {
        resolve();
        return;
      }

      reject(new Error("Razorpay loaded, but window.Razorpay is unavailable."));
    }

    function onError() {
      cleanup();
      reject(new Error("Failed to load Razorpay checkout script."));
    }

    const script = existingScript ?? document.createElement("script");
    script.id = RAZORPAY_SCRIPT_ID;
    script.async = true;
    script.src = RAZORPAY_SCRIPT_SRC;
    script.addEventListener("load", onLoad);
    script.addEventListener("error", onError);

    if (!existingScript) {
      document.head.appendChild(script);
    }
  }).catch((error) => {
    razorpayLoadPromise = null;
    throw error;
  });

  return razorpayLoadPromise;
}
